import { gql } from 'apollo-angular';

export const RemoveFromFunnelDocument = gql(/* GraphQL*/ `mutation removeFromFunnel($id: Int!) {
  removeFromFunnel(tacticId: $id)
}
`);
